import React from 'react';
import { Section, preloader } from 'spectacle-ppa';

import balloonSlide from '../../baseSlides/balloonSlide';
import headingSlide from '../../baseSlides/headingSlide';

import imageEPSLogo from '../../images/emergencyPreparednessSquadGlow.png';
import ianHandRaised from '../../images/characters/ian_hand_raised.png';
import ianSaraSide from '../../images/characters/ian_sara_side.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './ending.md';

const md = new MarkdownScript(markdownFile);

export function preloadEnding() {
  preloader([
    ianHandRaised,
    ianSaraSide,
    imageEPSLogo
  ]);
}

function endingSection({ regionData }) {
  return (
    <Section id="ending">

      {/* Time to see who won! */}
      {balloonSlide({
        id: 'announce-winners',
        characterSide: 'right',
        characterImage: ianHandRaised,
        html: md.getSubSectionAsHtml('Announce Winners', 'Content', false, regionData),
        notes: md.getSubSectionAsHtml('Announce Winners', 'Notes', false, regionData)
      })}

      {/* You're now all members of the Emergency Preparedness Squad */}
      {balloonSlide({
        id: 'members-of-eps',
        characterSide: 'right',
        characterImage: ianSaraSide,
        html: md.getSubSectionAsHtml('Members EPS', 'Content', false, regionData),
        notes: md.getSubSectionAsHtml('Members EPS', 'Notes', false, regionData)
      })}

      {/* You've completed all the levels */}
      {headingSlide({
        id: 'completed',
        beforeImage: imageEPSLogo,
        subHeading: 'All levels completed!!!',
        notes: md.getSubSectionAsHtml('All Levels Completed', 'Notes', false, regionData),
        bgColor: 'black'
      })}

    </Section>
  );
}

export default endingSection;



// WEBPACK FOOTER //
// ./programs/epsHybridPrimaries/sections/95_ending/endingSection.jsx